import { Helmet } from "react-helmet";
import { Button, Text, Img } from "../../components";
import PLTemplateComponent from "../../components/PLTemplateComponent";
import CaseStudySection from "./CaseStudySection";
import React, { useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function CasepagePage() {
  const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
  return (
    <>
      <Helmet>
        <title>Restaurant P&L Trend Analysis - Optimize Your Profitability</title>
        <meta
          name="description"
          content="Discover the importance of a Profit and Loss Statement with our Restaurant P&L Trend Analysis. Gain insights into operational decisions and their impact on success. Download templates and learn to enhance profitability."
        />
      </Helmet>
      <div className="w-full overflow-x-scroll ">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <div className="flex flex-col items-center gap-[22px]">
              <div className="self-stretch bg-white-a700">
                <div className="flex flex-col items-start">
                  <div className="flex flex-col items-center rounded-[20px]">
                    <Link
                      to={".."}
                      className="flex h-[40px] w-[40px] items-center justify-center rounded-[20px] px-2">
                      <Img src="images/img_arrow_left.svg" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="container-sm flex flex-col items-center px-14 lg:px-5 md:px-5 my-2">
                <div className="flex w-[20%] flex-col items-center gap-0.5 lg:w-full md:w-full">
                  <div className="mb-2 flex items-center self-stretch sm:items-start sm:justify-center">
                    <Img
                      src="images/img_checkmark.svg"
                      alt="Checkmark"
                      className="h-[16px]"
                    />
                    <Text as="p" className="self-end text-[14px] font-normal">
                      <span className="text-gray-700">Verified by&nbsp;</span>
                      <span className="text-orange-900">Suplyd</span>
                    </Text>
                  </div>
                  <Text
                    size="text3xl"
                    as="p"
                    className="lg:text-[18px] lg:font-bold text-center leading-5 !text-black-900_01"
                  >
                    How To Create Restaurant P&L Trend Analysis?
                  </Text>
                </div>
              </div>
            </div>
            <div className="mr-[828px] flex gap-2 overflow-x-scroll md:mr-0 md:flex-col sm:flex-row">
              <PLTemplateComponent className="md:px-5 sm:min-w-[333px]" />
              <PLTemplateComponent
                templateTitle="Costing Template"
                fiftyText="50"
                className="mr-2.5 md:mr-0 md:px-5 sm:min-w-[333px]"
              />
            </div>
          </div>
          <div className="mb-1 flex flex-col gap-2">
            {/* case study section */}
            <CaseStudySection />
            <div className="flex border-t border-solid border-gray-200 bg-white-a700 py-4">
              <div className="container-sm flex items-center justify-center lg:px-5 md:px-5">
                <div className="flex flex-1 flex-col items-start gap-1.5">
                  <Text size="text2xl" as="p" className="text-[16px] font-normal !text-gray-900_02 lg:text-[13px]">
                    Price
                  </Text>
                  <Text size="text2xl" as="p" className="text-[16px] font-normal !text-orange-900 lg:text-[13px]">
                    300 EGP
                  </Text>
                </div>
                <Button disabled className="flex h-[44px] disabled:opacity-50 min-w-[188px] flex-row items-center justify-center rounded-[10px] bg-orange-900 px-8 text-center font-inter text-[16px] font-medium text-white-a700 lg:text-[13px] sm:px-4">
                  Buy Case Study
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
